module.exports = __webpack_public_path__ + "img/cszq_icon.d5589d9c.jpg";